require('./bootstrap');
require('./password-generator');